import { Injectable } from '@angular/core';
import { AppIcons, IIcons } from '@datachain/ui-sdk/components/dc-icon';

export enum GdIcons {
	PersistInMemory = 'Generics:persist-memory',
	PersistInDisk = 'Generics:persist-disk',
	Search = 'Generics:search',
	DataBlock = 'Generics:datablock',
	Entity = 'Generics:entity',
	Depot = 'Generics:depot',
	Connector = 'Generics:connector',
}

@Injectable()
export class AppGdIcons extends AppIcons {
	private readonly path = './src/img';
	protected namespace = 'Generics';

	protected icons: IIcons = {
		[GdIcons.PersistInMemory]: `${this.path}/gd/persist-memory.svg`,
		[GdIcons.PersistInDisk]: `${this.path}/gd/persist-disk.svg`,
		[GdIcons.Search]: `${this.path}/svg/icon-preview.svg`,
		[GdIcons.DataBlock]: `${this.path}/gd/dc-datablock-solid.svg`,
		[GdIcons.Entity]: `${this.path}/gd/dc-entity-solid.svg`,
		[GdIcons.Depot]: `${this.path}/gd/dc-depot-solid.svg`,
		[GdIcons.Connector]: `${this.path}/gd/dc-connector-solid.svg`,
	};
}
